// Dynamic SEO-Friendly Shopify Search Redirect Script
// Automatically handles singular/plural forms and validates collections

document.addEventListener('DOMContentLoaded', function() {
    // Collection validation cache to avoid repeated API calls
    const collectionCache = new Map();

    // =================================================================
    // NEW: Handle browser back/forward cache (bfcache)
    // This resets the search button if the user navigates back to the page.
    // =================================================================
    window.addEventListener('pageshow', function(event) {
        // 'event.persisted' is true if the page was restored from the cache
        if (event.persisted) {
            const searchForm = document.querySelector('form[action="/search"][data-seo-enabled]');
            if (searchForm) {
                const submitButton = searchForm.querySelector('button[type="submit"]');
                if (submitButton) {
                    const originalHTML = submitButton.getAttribute('data-original-html');
                    if (originalHTML) {
                        submitButton.innerHTML = originalHTML;
                    }
                    submitButton.disabled = false;
                }
            }
        }
    });


    // Check if a collection exists
    async function collectionExists(handle) {
        if (collectionCache.has(handle)) {
            return collectionCache.get(handle);
        }
        try {
            const response = await fetch(`/collections/${handle}`, { method: 'HEAD' });
            const exists = response.ok && response.status === 200;
            collectionCache.set(handle, exists);
            return exists;
        } catch (error) {
            console.log(`Collection check failed for ${handle}:`, error);
            collectionCache.set(handle, false);
            return false;
        }
    }

    // Clean search term for URL
    function cleanSearchTerm(term) {
        return term.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    }

    // Dynamic pluralization rules
    function makePlural(word) {
        const irregulars = {'man':'men','woman':'women','child':'children','foot':'feet','tooth':'teeth','mouse':'mice','goose':'geese'};
        if (irregulars[word]) return irregulars[word];
        if (word.endsWith('s')||word.endsWith('sh')||word.endsWith('ch')||word.endsWith('x')||word.endsWith('z')) return word + 'es';
        if (word.endsWith('y') && !/[aeiou]y$/.test(word)) return word.slice(0, -1) + 'ies';
        if (word.endsWith('f')) return word.slice(0, -1) + 'ves';
        if (word.endsWith('fe')) return word.slice(0, -2) + 'ves';
        if (word.endsWith('o') && !/[aeiou]o$/.test(word)) return word + 'es';
        return word + 's';
    }

    // Dynamic singularization rules
    function makeSingular(word) {
        const irregulars = {'men':'man','women':'woman','children':'child','feet':'foot','teeth':'tooth','mice':'mouse','geese':'goose'};
        if (irregulars[word]) return irregulars[word];
        if (word.endsWith('ies')) return word.slice(0, -3) + 'y';
        if (word.endsWith('ves')) return word.endsWith('ives') ? word.slice(0, -4) + 'ife' : word.slice(0, -3) + 'f';
        if (word.endsWith('ses')||word.endsWith('shes')||word.endsWith('ches')||word.endsWith('xes')||word.endsWith('zes')) return word.slice(0, -2);
        if (word.endsWith('oes') && word.length > 3) return word.slice(0, -2);
        if (word.endsWith('s') && !word.endsWith('ss')) return word.slice(0, -1);
        return word;
    }

    // Generate collection handle variations to try
    function generateHandleVariations(searchTerm) {
        const cleaned = cleanSearchTerm(searchTerm);
        if (!cleaned) return [];
        const variations = new Set([cleaned]);
        const words = cleaned.split('-');
        if (words.length === 1) {
            variations.add(makePlural(words[0]));
            variations.add(makeSingular(words[0]));
        } else {
            variations.add(words.join('-'));
            variations.add(words.map(makePlural).join('-'));
            variations.add(words.map(makeSingular).join('-'));
            const lastPlural = [...words]; lastPlural[lastPlural.length - 1] = makePlural(words[words.length - 1]);
            variations.add(lastPlural.join('-'));
            const lastSingular = [...words]; lastSingular[lastSingular.length - 1] = makeSingular(words[words.length - 1]);
            variations.add(lastSingular.join('-'));
        }
        return Array.from(variations).filter(v => v && v.length > 0);
    }

    // Find the first existing collection from variations
    async function findExistingCollection(searchTerm) {
        const variations = generateHandleVariations(searchTerm);
        for (const handle of variations) {
            if (await collectionExists(handle)) {
                return handle;
            }
        }
        return null;
    }

    // Initialize search form interception
    function initSEOSearch() {
        const searchForm = document.querySelector('form[action="/search"]');

        if (searchForm && !searchForm.hasAttribute('data-seo-enabled')) {
            searchForm.setAttribute('data-seo-enabled', 'true');

            // MODIFIED: Store the button's original content on the button itself
            const submitButton = searchForm.querySelector('button[type="submit"]');
            if (submitButton && !submitButton.hasAttribute('data-original-html')) {
                submitButton.setAttribute('data-original-html', submitButton.innerHTML);
            }

            searchForm.addEventListener('submit', async function(e) {
                e.preventDefault();

                const searchInput = this.querySelector('input[name="q"]');
                const searchTerm = searchInput ? searchInput.value.trim() : '';

                if (!searchTerm) {
                    this.submit();
                    return;
                }

                // Show loading state
                if (submitButton) {
                    submitButton.innerHTML = '⏳';
                    submitButton.disabled = true;
                }

                try {
                    const existingHandle = await findExistingCollection(searchTerm);
                    if (existingHandle) {
                        window.location.href = `/collections/${existingHandle}`;
                        return;
                    }
                } catch (error) {
                    console.log('Collection lookup failed, using default search:', error);
                }

                // --- Fallback to Default Search ---
                // MODIFIED: Reset button using the stored original content
                if (submitButton) {
                    const originalHTML = submitButton.getAttribute('data-original-html');
                    if (originalHTML) {
                        submitButton.innerHTML = originalHTML;
                    }
                    submitButton.disabled = false;
                }

                this.submit();
            });
        }
    }

    // Run on page load
    initSEOSearch();

    // Run periodically to catch dynamically loaded forms
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                initSEOSearch();
            }
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});